/**
 * @bos/portal3 — tRPC v11 client over `/api/trpc` (superjson transformer).
 *
 * `AppRouter` is a TYPE-ONLY import from `@bos/portal3-server`: fully erased at
 * build time, so the SPA bundle never pulls the server runtime (better-sqlite3 et
 * al.) — but a renamed/retyped server procedure fails `tsc` at the call site here
 * instead of silently at runtime. `credentials: 'include'` is set now so M2's
 * httpOnly session cookie rides every call the moment it exists.
 */
import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';
import type { AppRouter } from '@bos/portal3-server';

export const client = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: '/api/trpc',
      transformer: superjson,
      fetch: (input, init) =>
        fetch(input as RequestInfo | URL, { ...(init ?? {}), credentials: 'include' }),
    }),
  ],
});
